<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="$t('passports.test')"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header class="transparent">
                  {{ $t("passports.headers") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="(value, key) in testAxiosHeaders" :key="key">
                          <td>{{ key }}</td>
                          <td>{{ value }}</td>
                        </tr>
                        <tr>
                          <td>Authorization</td>
                          <td>
                            <action-button
                              v-if="!authToken"
                              type="new"
                              :text="$t('passports.generate_auth_token')"
                              class="mx-0"
                              @click="showLoginForm()"
                              small
                            />
                            <span v-else style="word-break: break-all">{{ "Bearer " + authToken }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- MODULES -->
              <!-- <v-expansion-panel v-for="item in tenantAPIs" :key="item.module" v-if="authToken">
                <v-expansion-panel-header class="transparent">
                  {{ item.module }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-expansion-panel v-for="api in item.apis" :key="api.key">
                    <v-expansion-panel-header class="transparent elevation-4 subtitle-2">
                      <v-chip :color="methodColor(api.method)" small class="mr-3">
                        {{ api.method }}
                      </v-chip>
                      {{ "/api/" + api.url }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="elevation-4">
                      <p>
                        <b>URL:</b>
                        <v-text-field
                          class="url-preview"
                          :prefix="'/api/' + setAPIUrlParam(api)"
                          :value="getQuery(api.key)"
                          @change="setQuery(api.key, $event)"
                          autocomplete="new-password"
                        ></v-text-field>
                      </p>
                      <div v-if="api.params.length > 0" class="params-box">
                        <p><b>Parameters:</b></p>
                        <v-simple-table dense>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th>{{ $t("passports.name") }}</th>
                                <th>{{ $t("passports.type") }}</th>
                                <th>{{ $t("passports.value") }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="param in api.params" :key="param.name">
                                <td>{{ param.name }}</td>
                                <td>{{ param.type }}</td>
                                <td>
                                  <v-text-field
                                    @change="paramFieldChange(api.key, param.name, $event)"
                                    :value="getParamValue(api.key, param.name)"
                                    autocomplete="new-password"
                                  ></v-text-field>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                      <action-button
                        class="d-block mx-0"
                        type="default"
                        color="info"
                        :text="$t('passports.execute')"
                        small
                        @click="executeAPI(api.key)"
                      />
                      <br />
                      <p><b>Responses:</b></p>

                      <div class="elevation-4 pa-3 response-box" v-if="getResponse(api.key)">
                        <tree-view :data="getResponse(api.key)" />
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panel-content>
              </v-expansion-panel> -->
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-container>

      <!-- LOGIN MODAL -->
      <v-dialog v-model="showLoginModal" persistent max-width="400px" class="mt-0">
        <v-card>
          <v-app-bar dark color="primary" dense>
            {{ $t("passports.login_title") }}
          </v-app-bar>
          <v-divider></v-divider>
          <v-card-text class="pa-5 pb-2">
            <v-form>
              <v-flex xs12>
                <v-text-field
                  :name="`email_${Date.now() + Math.random()}`"
                  v-model="login_email"
                  prepend-icon="person"
                  :label="$t('auth.email')"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                  type="text"
                  readonly
                  disabled
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :name="`password_${Date.now() + Math.random()}`"
                  v-model="login_password"
                  prepend-icon="lock"
                  :label="$t('auth.password')"
                  v-validate="'required'"
                  :error-messages="errors.collect('password')"
                  data-vv-name="password"
                  type="password"
                  persistent-hint
                  placeholder=" "
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <action-button type="new" :text="$t('passports.login')" @click="getAuthorizationToken()" small />
            <action-button type="cancel" @click="hideLoginForm()" small />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
import Vue from "vue"
import TreeView from "vue-json-tree-view"

Vue.use(TreeView)

export default {
  name: "Test",

  props: ["id"],

  data() {
    return {
      passport: {},
      authToken: null,

      loginModalKey: 0,
      showLoginModal: false,
      login_email: null,
      login_password: null,
      dictionary: {
        attributes: {
          email: this.$t("auth.email"),
          password: this.$t("auth.password")
        }
      },

      panel: [0, 1],

      testAxios: null,
      testAxiosHeaders: {},
      tenantAPIs: [],
      tenantAPIParams: [],
      tenantAPIQuery: [],
      responseAPIs: []
    }
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  created() {
    axios
      .get(this.API_URL + "passport/client/" + this.id)
      .then((res) => {
        this.passport = res.data.data
        this.login_email = this.user.email
        this.populateAxiosHeaders()
      })
      .catch((err) => console.log(err))
  },

  computed: {
    user: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    locale: {
      get() {
        return this.$getSetting("locale")
      }
    }
  },

  methods: {
    populateAxiosHeaders() {
      this.testAxiosHeaders = {
        "Client-Id": this.passport.id,
        "Client-Secret": this.passport.secret,
        "X-TenantId": this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`),
        "X-Tenant-Subdomain": this.SUBDOMAIN,
        "X-Locale": this.$getSetting("locale")
      }
    },

    initTenantAxios() {
      let axiosHeaders = JSON.parse(JSON.stringify(this.testAxiosHeaders))
      axiosHeaders["Authorization"] = "Bearer " + this.authToken

      this.testAxios = axios.create({
        baseURL: this.API_URL,
        headers: {
          common: axiosHeaders
        }
      })

      this.testAxios.interceptors.request.use(
        (config) => {
          this.$store.dispatch("master/setLoader", true)
          config.headers["X-Locale"] = this.$getSetting("locale")
          return config
        },
        (error) => {
          this.$store.dispatch("master/setLoader", false)
          return error.response
        }
      )

      this.testAxios.interceptors.response.use(
        (response) => {
          this.$store.dispatch("master/setLoader", false)
          return response
        },
        (error) => {
          this.$store.dispatch("master/setLoader", false)
          return error.response
        }
      )
    },
    initTenantAPIs() {
      // Param type: url, data
      let courseAPI = {
        module: this.$t("courses.title"),
        apis: [
          { key: "get-courses", method: "GET", url: "courses", query: "?page=1&rows_per_page=10", params: [] },
          {
            key: "get-course-id",
            method: "GET",
            url: "course/{id}",
            query: null,
            params: [{ name: "id", type: "url", datatype: "integer" }]
          }
        ]
      }
      let studentAPI = {
        module: this.$t("participants.title"),
        apis: [
          { key: "get-participants", method: "GET", url: "participants", query: "?page=1&rows_per_page=10", params: [] },
          {
            key: "get-participant-id",
            method: "GET",
            url: "participant/{id}",
            query: null,
            params: [{ name: "id", type: "url", datatype: "integer" }]
          }
        ]
      }

      this.tenantAPIs.push(courseAPI)
      this.tenantAPIs.push(studentAPI)

      // Initiate response APIs
      this.tenantAPIs.forEach((module) => {
        module.apis.forEach((api) => {
          this.responseAPIs.push({
            key: api.key,
            data: null
          })

          this.tenantAPIQuery.push({
            key: api.key,
            value: api.query
          })

          api.params.forEach((param) => {
            this.tenantAPIParams.push({
              key: api.key,
              type: param.type,
              param_name: param.name,
              value: null
            })
          })
        })
      })
    },

    getAPI(key) {
      let module = this.tenantAPIs.find((i) => {
        return i.apis.find((j) => j.key == key)
      })

      if (module) {
        let api = module.apis.find((k) => k.key == key)

        if (api) {
          return api
        }
      }

      return null
    },
    getResponse(key) {
      let response = this.responseAPIs.find((i) => i.key == key)
      if (response) {
        return response.data || ""
      }

      return ""
    },
    getQuery(key) {
      let query = this.tenantAPIQuery.find((i) => i.key == key)

      if (query) {
        return query.value || ""
      }

      return ""
    },
    setQuery(key, value) {
      let query = this.tenantAPIQuery.find((i) => i.key == key)

      if (query) {
        query.value = value
      }
    },
    getParam(key, param_name) {
      let param = this.tenantAPIParams.find((i) => i.key == key && i.param_name == param_name)
      if (param) {
        return param
      }

      return null
    },
    getParamValue(key, param_name) {
      let param = this.getParam(key, param_name)
      if (param) {
        return param.value
      }

      return null
    },
    paramFieldChange(key, param_name, value) {
      let param = this.tenantAPIParams.find((i) => i.key == key && i.param_name == param_name)

      if (param) {
        param.value = value
      }
    },
    setAPIUrlParam(api) {
      var url = api.url

      var pattern = /[^{}]+(?=})/g
      var url_params = api.url.match(pattern)

      if (url_params) {
        url_params.forEach((url_param) => {
          var param = this.getParam(api.key, url_param)
          if (param && param.type == "url" && param.value) {
            url = url.replace("{" + url_param + "}", param.value)
          }
        })
      }

      return url
    },
    setAPIDataParam(url) {},
    executeAPI(key) {
      let vm = this
      let api = this.getAPI(key)

      if (api) {
        let params = {}
        let url = this.setAPIUrlParam(api)
        let query = this.getQuery(api.key)

        this.testAxios({
          method: api.method,
          url: url + query,
          data: params
        })
          .then(function (ret) {
            let response = vm.responseAPIs.find((i) => i.key == key)
            response.data = ret.data
          })
          .catch((error) => {})
      }
    },

    showLoginForm() {
      this.$setClientTenantInAxiosHeader(this.passport.id, this.passport.secret)
      this.showLoginModal = true
    },
    hideLoginForm() {
      this.$unsetClientTenantInAxiosHeader()
      this.showLoginModal = false
      this.login_password = null
    },

    getAuthorizationToken() {
      let vm = this
      this.$validator
        .validateAll()
        .then((valid) => {
          if (valid) {
            axios
              .post(this.API_URL + "auth/login", {
                email: vm.login_email,
                password: vm.login_password
              })
              .then((res) => {
                vm.authToken = res.data.access_token

                if (vm.authToken) {
                  vm.hideLoginForm()
                  vm.initTenantAxios()
                  vm.initTenantAPIs()
                } else {
                  vm.login_password = null
                  vm.$awn.alert(vm.$t("auth.login_error"))
                }
              })
              .catch((err) => console.log(err))
          }
        })
        .catch(() => {})
    },
    methodColor(type) {
      let color = "info"

      switch (type) {
        case "GET":
          color = "info"
          break
        case "POST":
          color = "success"
          break
        case "PUT":
          color = "warning"
          break
        case "DELETE":
          color = "error"
          break
      }

      return color
    }
  }
}
</script>

<style>
.v-expansion-panel-header > .v-chip {
  flex: none !important;
  -webkit-box-flex: none !important;
}
.response-box {
  max-height: 300px;
  overflow-y: scroll;
}
.url-preview .v-text-field__prefix {
  font-size: 14px !important;
}
</style>
